/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AdaptedFacesPainScaleAliases {
  CONTEXTUAL_BAR_ADAPTED_FACES = 'contextual-bar-adapted-faces',
  LAYOUT_ADAPTED_FACES = 'layout-adapted-faces',
  PAIN_SCALE_ADAPTED_FACES = 'pain-scale-adapted-faces',
  PANEL_ADAPTED_FACES = 'panel-adapted-faces',
}
export { AdaptedFacesPainScaleAliases };
